var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.75 18.75C3.75 22.2855 3.75 24.0532 4.84835 25.1516C5.9467 26.25 7.71446 26.25 11.25 26.25H18.75C22.2855 26.25 24.0532 26.25 25.1516 25.1516C26.25 24.0532 26.25 22.2855 26.25 18.75",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75V20M15 20L20 14.5312M15 20L10 14.5312",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon3);
export default __webpack_public_path__ + "static/media/download-icon3.c76b5a216aa067d6bd256481dda265fb.svg";
export { ForwardRef as ReactComponent };